module.exports = "<div [formGroup]=\"form\">\n  <input type=\"hidden\" [formControlName]=\"controlName\">\n</div>\n<input\n  #fileInput\n  type=\"file\"\n  [id]=\"id\"\n  [ngClass]=\"class\"\n  [accept]=\"acceptedExtensions\"\n  (change)=\"onFileChange()\"\n>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/file-input/file-input.component.html
// module id = ../../../../../src/app/shared/components/forms/file-input/file-input.component.html
// module chunks = main